<template>
  <footer
    class="py-[140px] sm:py-[180px] transition-all duration-250 ease-in-out"
  >
    <div class="flex flex-col items-center justify-center">
      <nuxt-link :to="{ name: 'home' }" class="items-center">
        <SpriteSymbol name="logo" class="aspect-[100/36] h-10 text-red" />
      </nuxt-link>

      <div class="flex flex-col items-center justify-center mt-10 gap-4">
        <VuepalLink
          v-for="link in footerButtonsLinks"
          :key="link.id"
          :to="link.href"
          class="button"
        >
          {{ link.label }}
          <SpriteSymbol name="arrow-right" class="size-6" />
        </VuepalLink>
      </div>

      <div class="mt-10 flex items-center gap-4">
        <VuepalLink
          v-for="link in footerSocialMediaLinks"
          :key="link.id"
          :to="link.href"
          target="_blank"
          :aria-label="link.label"
          class="flex items-center justify-center bg-white rounded-full text-darkGreen size-10 hover:bg-darkGreen hover:text-white transition-all ease-in-out duration-250"
        >
          <SpriteSymbol
            :name="getSocialIconName(link.href)"
            :alt="link.label"
            class="size-6 flex scale-75"
          />
        </VuepalLink>
      </div>
      <div
        class="flex flex-col sm:flex-row items-center justify-center mt-5 gap-4"
      >
        <VuepalLink
          v-for="link in footerMenuLinks"
          :key="link.id"
          :to="link.href"
          class="text-gray-800 hover:text-violet transition-all duration-250 ease-in-out"
        >
          {{ link.label }}
        </VuepalLink>
        <div class="text-gray-800">&copy; {{ year }} AOZ</div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-icon-sprite/runtime'

const year = computed(() => {
  return new Date().getFullYear().toString()
})

// Get social media links from init data
const { footerMenuLinks, footerSocialMediaLinks, footerButtonsLinks } =
  useInitData()

// Function to determine the icon name based on URL (similar to the inspiration)
function getSocialIconName(url = ''): NuxtSvgSpriteSymbol {
  if (!url) return 'close' // Default fallback

  if (url.includes('facebook.com')) {
    return 'facebook'
  } else if (url.includes('linkedin.com')) {
    return 'linkedin'
  } else if (url.includes('instagram.com')) {
    return 'instagram'
  }

  return 'close' // Default fallback
}
</script>
